import * as types from './mutations-types'

export const setFormData = ({ commit }, data) => {
  commit(types.SET_FORM_DATA, data)
}

export const resetFormData = ({ commit }) => {
  commit(types.RESET_FORM_DATA)
}
